import { render, staticRenderFns } from "./ModalOptionsPeople.vue?vue&type=template&id=77b6b4c0&"
import script from "./ModalOptionsPeople.vue?vue&type=script&lang=js&"
export * from "./ModalOptionsPeople.vue?vue&type=script&lang=js&"
import style0 from "./ModalOptionsPeople.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports